import { useQuery } from "@tanstack/react-query";
import Product from "../interfaces/product";
import { PRODUCT_URL } from "../util/constants";
import useApi from "./useApi";
import PageParams from "../interfaces/pageParams";

const usePagedProduct = (params: PageParams) => {
    const { getPage } = useApi<Product>(PRODUCT_URL);

    return useQuery({
        queryKey: ["products", "paged", params],
        queryFn: () => getPage({ params: { ...params } }),
        staleTime: 1000 * 60 * 5,
        placeholderData: (previousData) => previousData,
    });
};

export default usePagedProduct;
